export const STORE_KEY = {
  EVENT: 'event',
  GLOBAL: {
    AUTH: 'global.auth',
    GAME: 'global.game',
    ROUTER: 'global.router',
    WATER_MARK_CONTENT: 'global.water_mark_content',
  },
  BI: {
    UA: 'bi_ua',
    PIVOT: 'bi_pivot',
  },
  CONTENT_MARKETING: {
    CONTENT_INSIGHTS: 'content_insights',
    HOTSPORT_RADAR: 'hotspot_radar',
  },
};
